const state = {
  visitedViews: [],
  cachedViews: []
}

/** 只存可序列化字段，禁止把 $route.matched / component 放进 Vuex（会和 Layout 环引用爆栈） */
function normalizeView(view) {
  if (!view || !view.path) return null
  const meta = view.meta && typeof view.meta === 'object' ? { ...view.meta } : {}
  return {
    path: view.path,
    fullPath: view.fullPath || view.path,
    name: view.name || '',
    title: meta.title || view.title || '',
    query: view.query && typeof view.query === 'object' ? { ...view.query } : {},
    meta
  }
}

const mutations = {
  ADD_VISITED_VIEW(state, view) {
    const tag = normalizeView(view)
    if (!tag) return
    if (tag.name === 'Redirect' || String(tag.path).indexOf('/redirect') === 0) return
    if (tag.meta && tag.meta.hidden) return
    if (!tag.title) return
    if (state.visitedViews.some(v => v.path === tag.path)) return
    state.visitedViews.push(tag)
  },
  ADD_CACHED_VIEW(state, view) {
    if (!view || !view.name || view.name === 'Redirect') return
    if (view.meta && view.meta.hidden) return
    if (state.cachedViews.includes(view.name)) return
    if (view.meta && !view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
  },
  DEL_VISITED_VIEW(state, view) {
    const index = state.visitedViews.findIndex(v => v.path === view.path)
    if (index > -1) state.visitedViews.splice(index, 1)
  },
  DEL_CACHED_VIEW(state, view) {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) state.cachedViews.splice(index, 1)
  },
  DEL_OTHERS_VISITED_VIEWS(state, view) {
    state.visitedViews = state.visitedViews.filter(v => v.meta.affix || v.path === view.path)
  },
  DEL_OTHERS_CACHED_VIEWS(state, view) {
    const index = state.cachedViews.indexOf(view.name)
    state.cachedViews = index > -1 ? state.cachedViews.slice(index, index + 1) : []
  },
  DEL_ALL_VISITED_VIEWS(state) {
    state.visitedViews = []
  },
  DEL_ALL_CACHED_VIEWS(state) {
    state.cachedViews = []
  },
  UPDATE_VISITED_VIEW(state, view) {
    const tag = normalizeView(view)
    if (!tag) return
    const index = state.visitedViews.findIndex(v => v.path === tag.path)
    if (index > -1) {
      state.visitedViews.splice(index, 1, Object.assign({}, state.visitedViews[index], tag))
    }
  }
}

const actions = {
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view)
    dispatch('addCachedView', view)
  },
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },
  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({ visitedViews: [...state.visitedViews], cachedViews: [...state.cachedViews] })
    })
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },
  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view)
      dispatch('delOthersCachedViews', view)
      resolve({ visitedViews: [...state.visitedViews], cachedViews: [...state.cachedViews] })
    })
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.cachedViews])
    })
  },
  delAllViews({ dispatch, state }) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews')
      dispatch('delAllCachedViews')
      resolve({ visitedViews: [...state.visitedViews], cachedViews: [...state.cachedViews] })
    })
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.cachedViews])
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
